import { SMSIconFilled } from '@rsos/assets/icons';
import { LocationSources, SOURCE_TCAPI } from '@rsos/constants/locationSources';

export const TT911_MESSAGE = 'Text-to-911 Message: Inbound Emergency Request';

export const getToastMessage = (source?: LocationSources | null) => {
  if (!source) return null;

  if (source === SOURCE_TCAPI) {
    return TT911_MESSAGE;
  }

  return null;
};

export const getToastIcon = () => {
  return <SMSIconFilled data-name="conversations-toast-sms-icon" />;
};

export const getToastButtonText = (source: LocationSources) => {
  if (source === SOURCE_TCAPI) {
    return 'Accept';
  }

  return 'View';
};
